import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'design',
directives: {
TransferDom
},
components: {
XButton, Tab, TabItem, Scroller, Spinner, Popup, Confirm, Swiper, SwiperItem,
},
data () {
return {


downUrl: this.$baseURL+'/file/download',
synthesizeSort:false,
isLatestReleaseSort: false,
isPopulaceSort: false,

show13: false,

list: [],
page: 1,
postStatus: "综合排序",
postOrderDesc: '0',
releaseOrderDesc: true,
completedOrderDesc: false,
canceledOrderDesc: false,
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
showConfirm: false,
takeOrdersId: '',
takeOrdersIndex: '',
confirmText: '',
confirmEvent: '',
confirmImg: '',
synthesizeActive:true,
newestActive:false,
moneyActive:false,

details: {
requireType: '',  //需求分类
projectType: '',  //项目分类
title: '',  //项目名称
pieceCount: '',  //面数
surfaceCount: '',  //面数
reqdate: '',  //截止日期
price: '',  //赏金
qq: '',  //qq
mailbox: '',  //邮箱
phone: '',  //手机号码
detail: '',  //详细描述
}
}
},
methods: {
designDetail (data,index) {
this.show13 = true
this.details = data
this.details.index = index
console.log(data)



},
closeDetail () {
this.show13 = false
},
release () {
this.synthesizeActive = true
this.newestActive = false
this.moneyActive = false
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.releaseOrderDesc = !this.releaseOrderDesc

this.list = []
this.page = 1
this.postStatus = '综合排序'
if(!this.releaseOrderDesc){
this.postOrderDesc = '1'
}else{
this.postOrderDesc = '0'
}
this.loadMore()
},
downloadFiles (url) {
window.open(url)
},
completed () {
this.synthesizeActive = false
this.newestActive = true
this.moneyActive = false
this.isLatestReleaseSort = !this.isLatestReleaseSort
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.completedOrderDesc = !this.completedOrderDesc
this.list = []
this.page = 1
this.postStatus = '最新发布'
if(!this.completedOrderDesc){
this.postOrderDesc = '0'
}else{
this.postOrderDesc = '1'
}
this.loadMore()
},
canceled () {
this.synthesizeActive = false
this.newestActive = false
this.moneyActive = true
this.isPopulaceSort = !this.isPopulaceSort
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.canceledOrderDesc = !this.canceledOrderDesc
this.list = []
this.page = 1
this.postStatus = '悬赏金'
if(!this.canceledOrderDesc){
this.postOrderDesc = '0'
}else{
this.postOrderDesc = '1'
}
this.loadMore()
},
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
getVideoList(cb) {
this.$request.post('/designtask/list',{
orderDesc: this.postOrderDesc,
page: this.page,
rows: 10,
token: this.getCookie('_token'),
orderType: this.postStatus
},).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
})
},
refresh() {
this.page = 1
this.getVideoList(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.getVideoList(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
takeOrders (id,index) {  //点击 接单 按钮

















if(!this.$common.getCookie('_token')){
this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
})
return false;
}

console.log(id)
console.log(index)
this.confirmText = '确定要接这个单吗？'
this.confirmEvent = 'takeOrders'
this.showConfirm = true
this.takeOrdersIndex = index
this.takeOrdersId = id
this.confirmImg = require('../../assets/images/blueWarn.png')
},
onCancel () {
console.log('取消')
},
onConfirm () {    //确定 接单
console.log(this.takeOrdersId)
let url,msg;
if(this.confirmEvent == 'takeOrders'){  //接单
url = '/designtask/receipt'
msg = '已接单'
}
this.$request.post(url,{
designTaskId: this.takeOrdersId,
token: this.getCookie('_token')
},).then(data => {
if(data.code == 0){
this.details.receivedOrders = 1
this.details.phone = data.obj.phone
this.details.qq = data.obj.qq
this.details.mailbox = data.obj.mailbox
this.list[this.takeOrdersIndex].receivedOrders = 1
this.list[this.takeOrdersIndex].phone = data.obj.phone
this.list[this.takeOrdersIndex].qq = data.obj.qq
this.list[this.takeOrdersIndex].mailbox = data.obj.mailbox
this.$vux.toast.show({
type: 'success',
text: msg
})
console.log(data)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
},
created () {



this.loadMore()

meteor.track('view', {convert_id: 1674350289804292 })
},




}



// WEBPACK FOOTER //
// ./src/views/design/script.js